import { WatchQueryFetchPolicy } from '@apollo/client';
import { useGetInteractiveLessonParams } from '../activity-builder.hooks';
import { GET_CLASS_STUDENT_ANSWERS } from './activity-answers.graphql';
import { useLoggingQuery } from 'lib/apollo/apollo-hooks';
import type {
  GetClassStudentAnswersQuery,
  GetClassStudentAnswersQueryVariables,
} from './activity-answers.graphql.generated';

export const useGetStudentAnswersOverview = ({
  studentId,
  classId,
  fetchPolicy,
  pollInterval,
  componentId,
  skip,
}: {
  studentId?: number | null;
  classId: number | null;
  componentId?: string | null;
  fetchPolicy?: WatchQueryFetchPolicy;
  pollInterval?: number;
  skip?: boolean;
}) => {
  const { contentId, contentType, version } = useGetInteractiveLessonParams();

  const { data, loading, error } = useLoggingQuery<
    GetClassStudentAnswersQuery,
    GetClassStudentAnswersQueryVariables
  >(GET_CLASS_STUDENT_ANSWERS, {
    skip: !version || !classId || skip,
    fetchPolicy,
    pollInterval: pollInterval || 0,
    variables: {
      input: {
        classId: classId || 1,
        contentId,
        contentType,
        contentVersion: version!,
        studentId,
        componentId,
        loadDrawingData: false,
      },
    },
  });

  return {
    data,
    loading,
    error,
  };
};
